import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-astcomputerscienceengineering',
  templateUrl: './astcomputerscienceengineering.component.html',
  styleUrls: ['./astcomputerscienceengineering.component.scss']
})
export class AstcomputerscienceengineeringComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
